<div class="table skeleton-table-small-container">
  <div class="table-cell skeleton-table-small-cell--first">
    <span class="skeleton-table-small-text slide-row"></span>
  </div>

  <div class="table-cell skeleton-table-small-cell--second">
    <span class="skeleton-table-small-text slide-row"></span>
  </div>

  <div class="table-cell skeleton-table-small-cell--third">
    <span class="skeleton-table-small-text slide-row"></span>
  </div>
</div>
